import React from "react";
import "@/app/pages/industryAnalysis/industry.scss";

const HeadingBlue = ({props}) => {
 const {title, titlePrefix, titleSuffix, isTintClassName} = props;
 let companyName = title.replace("null", "").trim();
  return <>
  <div className="industryHeroWrapper">
    <div className="content_card clearfix">
            <div className="tile hero">
                <div className={`img ${isTintClassName ? 'tint' : null}`}>
                    <div className="img img-responsive imgHero hero-placeholder"></div>
                        <div className="image tint heroImage">
                             <img width="1598" height="495" alt="" className="imgHero lazyloaded" />
                        </div>

                    </div>
                <div className="text">
                    <div className="container">
                        <div className="row pad-l-0">
                            <div className="col-md-12 pad-l-0">
                                <div className="meta">
                                    <h1 className="title heroBannerTitle">
                                               {companyName}{" "}{titlePrefix} <br />
                                               {titleSuffix}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
};

export default HeadingBlue;